export const DATE_FORMAT = 'MM/DD/YY';

export const MONITORING_CHART_MAX_WIDTH = 715;

export interface StageConfig {
  fields: readonly string[];
}

export const STAGE_CONFIG: Record<string, StageConfig> = {
  inquiriesToApps: {
    fields: ['inquiry', 'appRate', 'application'],
  },
  applicationsToAdmits: {
    fields: ['application', 'admitRate', 'admit'],
  },
  admitsToEnrollment: {
    fields: ['admit', 'yieldRate', 'netDeposit'],
  },
};
